export default __webpack_public_path__ + "static/media/backgroundcard.3dbd476f.png";